import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useGoogleMapsKey = () => {
  const [apiKey, setApiKey] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchApiKey = async () => {
      try {
        setIsLoading(true);
        const { data, error } = await supabase.functions.invoke('get-google-maps-key');
        
        if (error) {
          throw error;
        }
        
        if (!data?.GOOGLE_MAPS_API_KEY) {
          throw new Error('No API key returned from server');
        }

        setApiKey(data.GOOGLE_MAPS_API_KEY);
        setError("");
      } catch (err) {
        console.error('Error fetching Google Maps API key:', err);
        setError("Failed to load address search. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchApiKey();
  }, []);

  return { apiKey, error, isLoading };
};